module.exports = __webpack_public_path__ + "f0f4c1de08f21f4a70992dc4722c92ae.svg";